class TransactionsController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    edit() {
        transactionsOnEditOrNew();
    }

    new() {
        transactionsOnEditOrNew();
    }
}

window.BC = window.BC || {};
window.BC.transactions = new TransactionsController();

function transactionsOnEditOrNew() {
    blurToCurrency(0, [
        '#transaction_price',
        '#transaction_concessions',
        '#transaction_commbasis',
        '#transaction_commflat',
        '#transaction_commcredit'
    ]);
    blurToCurrency(2, [
        '#transaction_agent_charges'
    ]);
    blurToPercentage(2, [
        '#transaction_commpct'
    ]);
    blurToPercentage(0, [
        '#transaction_probability'
    ]);
    blurToPercentage(0, [
        '#transaction_referred_pct'
    ]);
    
    // Handle financing days input (check if already initialized to prevent multiple listeners)
    const financingDaysField = document.getElementById('transaction_financingdays');
    if (financingDaysField && !financingDaysField.dataset.dateCalculatorInitialized) {
        financingDaysField.dataset.dateCalculatorInitialized = 'true';
        const calculateFinancingDate = function() {
            const maInput = document.getElementById('ma-input');
            if (maInput && maInput.value !== "" && this.value !== "") {
                setDateByDays(maInput.value, this.value, '#transaction_financing');
            }
        };
        financingDaysField.addEventListener('input', calculateFinancingDate);
        financingDaysField.addEventListener('blur', calculateFinancingDate);
    }
    
    // Handle inspection days input (check if already initialized to prevent multiple listeners)
    const inspectionDaysField = document.getElementById('transaction_inspectiondays');
    if (inspectionDaysField && !inspectionDaysField.dataset.dateCalculatorInitialized) {
        inspectionDaysField.dataset.dateCalculatorInitialized = 'true';
        const calculateInspectionDate = function() {
            const maInput = document.getElementById('ma-input');
            if (maInput && maInput.value !== "" && this.value !== "") {
                setDateByDays(maInput.value, this.value, '#transaction_inspection');
            }
        };
        inspectionDaysField.addEventListener('input', calculateInspectionDate);
        inspectionDaysField.addEventListener('blur', calculateInspectionDate);
    }

    // Handle dynamic fields (now handled by bc.js addOrRemoveFields)
    addOrRemoveFields();
    
    // File upload now handled by modern Stimulus file-upload controller
    // Contact form submissions now handled by Stimulus contact-form controller
    
    // Handle send docs functionality
    const sendDocsButton = document.getElementById('sendDocs');
    if (sendDocsButton) {
        sendDocsButton.addEventListener('click', function() {
            let to = [];
            const checkboxes = [
                {id: 'sendtoclient', label: 'Client'},
                {id: 'sendtolender', label: 'Lender'},
                {id: 'sendtoescrow', label: 'Escrow'},
                {id: 'sendtooffice', label: 'Office'},
                {id: 'sendtootheragent', label: 'Other Agent'},
                {id: 'sendtome', label: 'Me!'}
            ];
            
            checkboxes.forEach(checkbox => {
                const element = document.getElementById(checkbox.id);
                if (element && element.checked) {
                    to.push(checkbox.label);
                }
            });
            
            alert("Sending Docs to: " + to.join(', '));
        });
    }
    
    // Handle document form changes
    document.addEventListener('change', function(event) {
        if (event.target.matches('.documentName, .client-can-see, .office-can-see, .escrow-can-see, .lender-can-see')) {
            const form = event.target.closest('form');
            if (form) {
                form.submit();
            }
        }
    });
}

function setDateByDays(mutual, days, datefield) {
    const params = new URLSearchParams({
        startdate: mutual,
        days: days
    });
    
    fetch(`/futuredate?${params}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        const dateField = document.querySelector(datefield);
        if (dateField) {
            // Convert MM/DD/YYYY to YYYY-MM-DD for HTML5 date inputs
            let formattedDate = data.newdate;
            if (data.newdate && data.newdate.includes('/')) {
                const [month, day, year] = data.newdate.split('/');
                formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
            dateField.value = formattedDate;
        }
    })
    .catch(error => {
        console.error('Error setting date:', error);
    });
}